<template>
  <v-container>
    <div>
      <v-row justify="start">
        <v-col cols="12" sm="3">
          <vc-date-picker mode="range" v-model="dateRange" :popover="{label: 'Hover', visibility: 'hover'}">
          </vc-date-picker>
        </v-col>

        <v-col cols="12" sm="2" justify="end">
          <v-btn color="primary" dark @click="getData">{{ $t('common.search') }}</v-btn>
        </v-col>

        <v-col cols="12" sm="7">
          <div class="d-flex flex-row-reverse">
            <v-btn color="primary" dark @click="getData">{{ $t('common.refresh') }}</v-btn>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-data-table :headers="headers" :items="desserts" :search="search" sort-by="date" :loading="loading"
                  class="elevation-1" hide-default-footer :page.sync="page" :items-per-page="itemsPerPage"
                  @page-count="pageCount = $event" :item-class="this.$statusAccountant">
      <template v-slot:top>
        <v-toolbar flat color="white" class="pt-5">
          <v-row justify="start">
            <v-col cols="12" sm="2">
              <span>Tổng số: <span class="summaryFont"> {{ totalManufactureRequest }} </span> </span>
            </v-col>

            <v-spacer></v-spacer>

            <v-col cols="12" sm="1">
              <v-autocomplete v-model="itemsPerPage" :items="numberPage" outlined :dense="true"></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2">
              <v-autocomplete v-model="selectReadStatus" :items="readStatus" item-text="title" outlined :dense="true" return-object></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="7">
              <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line
                            hide-details outlined :dense="true"></v-text-field>
            </v-col>
          </v-row>
        </v-toolbar>
      </template>

      <template v-slot:[`item.designer`]="{ item }">
        <div class="contentAddress" @click="showRateDialog(item.designer)" v-if="item.requestMethod !== 2">
          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-avatar v-on="on" size="30" class="mr-1">
                <img v-if="item.designer.avatar" :src="baseImage + item.designer.avatar"/>
                <img v-else src='@/assets/avatar_default.png'/>
              </v-avatar>
            </template>
            <span>
                  {{ item.designer.fullname }}
                </span>
          </v-tooltip>
          <span>
                {{ item.designer.nickname }}
              </span>
        </div>
      </template>


      <template v-slot:[`item.sale`]="{ item }">
        <div class="contentAddress">
          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-avatar v-on="on" size="30" class="mr-1">
                <img v-if="item.sale.avatar" :src="baseImage + item.sale.avatar"/>
                <img v-else src='@/assets/avatar_default.png'/>
              </v-avatar>
            </template>
            <span>
                  {{ item.sale.fullname }}
                </span>
          </v-tooltip>
          <span>
                {{ item.sale.nickname }}
              </span>
        </div>
      </template>


      <template v-slot:[`item.createdAt`]="{ item }">
        <span class="text-no-wrap">{{ item.createdAt | formateDate }}</span>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" small class="mr-2" @click="showDetail(item)">
              info
            </v-icon>
          </template>
          <span>Thông tin chi tiết</span>
        </v-tooltip>
      </template>

      <template v-slot:[`item.designRequest.requestTitle`]="{ item }">
              <span class="contentTitle">
<!--                {{ item.designRequest.requestTitle + (item.designRequest.orderUnit ? (' - ' + item.designRequest.orderUnit.name) : '') }}-->
                {{ getManufactureTitle(item) }}
              </span>
      </template>

      <template v-slot:[`item.customer.fullname`]="{ item }">
              <span class="contentName">
                {{ item.customer.fullname }}
              </span>
      </template>

      <template v-slot:no-data>
        <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
      </template>
    </v-data-table>

    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>

    <manufacture-request-dialog v-model="dialogDetail" :editedItem="editedItem" :editable="false"
                                @closeDialog="closeDetail"
                                v-if="editedItem">
    </manufacture-request-dialog>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import i18n from '@/plugins/i18n';
import moment from 'moment';
import ManufactureRequestDialog from "@/components/ManufactureRequestDialog";
import socketClient from "@/plugins/socketClient";

export default {
  data: () => ({
    baseImage: process.env.VUE_APP_BASE_IMAGE,
    baseAttach: process.env.VUE_APP_BASE_ATTACH,

    dateRange: {start: new Date(new Date().setDate(new Date().getDate() - 7)), end: new Date()},
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    overlay: false,
    isSearching: false,

    loading: true,
    numberPage: [
      5, 10, 15, 20, 25
    ],

    selectReadStatus: {title: i18n.t('common.all'), value: -1},
    readStatus: [
      {title: i18n.t('common.unread'), value: 0},
      {title: i18n.t('common.read'), value: 1},
      {title: i18n.t('common.all'), value: -1}
    ],
    originalDesserts: [],

    selectedManufactureRequest: {},
    search: '',
    dialog: false,
    dialogDetail: false,
    designRequest: {},

    totalManufactureRequest: 0,

    headers: [
      {text: '#', align: 'left', sortable: false, value: 'index',},
      {text: i18n.t('design_manager.code_manufacture'), sortable: false, value: 'code'},
      {text: i18n.t('design_manager.code'), sortable: false, value: 'designRequest.code'},
      {text: i18n.t('design_manager.name'), sortable: false, value: 'designRequest.requestTitle'},
      // { text: i18n.t('design_manager.customer'), sortable: false, value: 'customer.fullname' },
      {text: i18n.t('design_manager.date'), value: 'createdAt'},
      {text: i18n.t('design_manager.sale'), sortable: false, value: 'sale'},
      {text: '', sortable: false, value: 'sale.fullname', align: ' d-none'},
      {text: i18n.t('design_manager.designer'), sortable: false, value: 'designer'},
      {text: '', sortable: false, value: 'designer.fullname', align: ' d-none'},
      // { text: i18n.t('manufacture_manager.status'), value: 'status', sortable: false ,  width: '150px'},
      {text: i18n.t('design_manager.infor'), align: 'center', sortable: false, value: 'action'}
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: null,

    stringRules: [
      v => !!v || i18n.t('validate.not_empty'),
      v => (v && v.length > 5) || i18n.t('validate.string_invalid')
    ]
  }),

  computed: {},

  components: {
    ManufactureRequestDialog: ManufactureRequestDialog
  },

  watch: {
    selectReadStatus() {
      this.filterData();
    },
  },

  created() {
    this.getData();
    this.isSearching = true;

    const self = this;
    socketClient.getIO().on('MANUFACTURE_REQUEST_FINISH', () => {
      self.getData();
    });
  },

  methods: {
    initialize() {
    },

    getManufactureTitle(item) {
      return this.$getManufactureTitle(item);
    },

    closeDetail(value) {
      this.dialogDetail = value
      this.editedItem = null;
    },

    showDetail(item) {
      this.editedIndex = this.desserts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDetail = true;
    },

    filterData() {
      if (this.selectReadStatus.value !== -1) {
        this.desserts = [].concat(this.originalDesserts.filter(item => item.accountantReadStatus == this.selectReadStatus.value));
      } else {
        this.desserts = [].concat(this.originalDesserts);
      }

      this.totalManufactureRequest = this.desserts.length;
    },

    async getData() {
      this.overlay = this.isSearching;
      try {
        // const response = await this.$http.get('/designRequest');
        const from = moment(String(this.dateRange.start)).format("DD/MM/YYYY");
        const to = moment(String(this.dateRange.end)).format("DD/MM/YYYY");

        const response = await this.$http.get('/manufactureRequest/status/4?' + "from=" + from + "&to=" + to);
        this.overlay = false;
        if (response.data && response.data.success) {
          const contextArr = response.data.data;
          contextArr.forEach((item, index) => item.index = index + 1);
          this.desserts = contextArr;
          this.originalDesserts = contextArr;

          this.totalManufactureRequest = this.desserts.length;

          this.loading = false;
        }
      } catch (e) {
        console.log(e.stack);
      }
    },
  },
}
</script>

<style scoped>
.linkText {
  color: #F08942
}

.small-button {
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  color: #F08942;
}

.nowrap-overflow {
  flex-wrap: nowrap;
  overflow-x: auto;
}
</style>